import RailsResource from './rails-resource';

class BookEntriesService extends RailsResource {
  constructor() {
    super({
      url: '/admin/financial/',
      resource: 'book-entries',
      ajaxLoader: false
    });
  }

  searchResourceEntryable(search_query) {
    return this.get(`${this.url}/${this.resource}/search_resource_entryable.json?search_query=${search_query}`);
  }

  getResourceEntryable(id) {
    return this.get(`${this.url}/${this.resource}/${id}/resource_entryable.json`);
  }
}

export default new BookEntriesService();
